export default {
  SET_CARDAPIO(state, tiposCardapios) {
    state.tiposCardapios.push(tiposCardapios)
  },

  SET_PAISES(state, paises) {
    state.paises = paises
  },
  SET_UVAS(state, uvas) {
    state.uvas = uvas
  }
}